import Snapshot from '../../../domain/note/snapshot/Snapshot'
import {NotesSnapshotResponse} from '../types'

export const toSnapshot = (response: NotesSnapshotResponse): Snapshot => {
  const {snapshot} = response
  return snapshot
}
